export const REQUEST_TIMEOUT = 15 * 60 * 1000; // 15 minutes

export default {};
